import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import FormattedDateTime from './FormattedDateTime';

loadDOMComponent({
	selector: 'react-formatted-datetime',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const dateTime = container.getAttribute('dateTime');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<FormattedDateTime dateTime={dateTime} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
